/* istanbul ignore file */

import { GeoJsonFeature } from './geo-json-feature-model';

export class GeoJsonFile {
    type = "FeatureCollection";
    features: GeoJsonFeature[];
}
